import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import _ from 'lodash';
const TextDiffAnalyzer = ({ oldTexts, newTexts }) => {
    const findWordDifferences = (oldText, newText) => {
        const oldWords = oldText.split(/(\s+|&)/).filter(word => word.trim());
        const newWords = newText.split(/(\s+|&)/).filter(word => word.trim());
        const differences = [];
        let oldIndex = 0;
        let newIndex = 0;
        while (oldIndex < oldWords.length || newIndex < newWords.length) {
            const oldWord = oldWords[oldIndex];
            const newWord = newWords[newIndex];
            if (!oldWord) {
                differences.push({
                    oldWord: '',
                    newWord: newWords.slice(newIndex).join(' ')
                });
                break;
            }
            if (!newWord) {
                differences.push({
                    oldWord: oldWords.slice(oldIndex).join(' '),
                    newWord: ''
                });
                break;
            }
            if (oldWord !== newWord) {
                let nextMatchOldIndex = oldIndex + 1;
                let nextMatchNewIndex = newIndex + 1;
                let found = false;
                while (nextMatchOldIndex <= oldWords.length && nextMatchNewIndex <= newWords.length && !found) {
                    if (oldWords[nextMatchOldIndex] === newWords[nextMatchNewIndex]) {
                        differences.push({
                            oldWord: oldWords.slice(oldIndex, nextMatchOldIndex).join(' '),
                            newWord: newWords.slice(newIndex, nextMatchNewIndex).join(' ')
                        });
                        oldIndex = nextMatchOldIndex;
                        newIndex = nextMatchNewIndex;
                        found = true;
                    }
                    else {
                        nextMatchOldIndex++;
                        nextMatchNewIndex++;
                    }
                }
                if (!found) {
                    differences.push({
                        oldWord: oldWords.slice(oldIndex).join(' '),
                        newWord: newWords.slice(newIndex).join(' ')
                    });
                    break;
                }
            }
            oldIndex++;
            newIndex++;
        }
        return differences;
    };
    const createCompleteText = (originalText, differences) => {
        if (differences.length === 0)
            return {
                beforeReplacement: originalText,
                oldText: '',
                newText: '',
                afterReplacement: ''
            };
        const firstDiff = differences[0];
        const lastDiff = differences[differences.length - 1];
        // Find the starting position of the first difference
        const startPos = originalText.indexOf(firstDiff.oldWord);
        // Find the ending position of the last difference
        const endPos = originalText.indexOf(lastDiff.oldWord) + lastDiff.oldWord.length;
        return {
            beforeReplacement: originalText.substring(0, startPos),
            oldText: originalText.substring(startPos, endPos),
            newText: differences.map(d => d.newWord).join(' '),
            afterReplacement: originalText.substring(endPos)
        };
    };
    const compareTexts = () => {
        return _.map(_.zip(oldTexts, newTexts), ([oldText, newText], index) => {
            if (!oldText || !newText)
                return null;
            const differences = findWordDifferences(oldText, newText);
            const changedOldText = differences
                .map(diff => diff.oldWord)
                .filter(word => word)
                .join(' ');
            const changedNewText = differences
                .map(diff => diff.newWord)
                .filter(word => word)
                .join(' ');
            return {
                index,
                differences,
                fullReplacement: {
                    oldText: changedOldText,
                    newText: changedNewText
                },
                completeText: createCompleteText(oldText, differences)
            };
        }).filter((result) => result !== null);
    };
    const results = compareTexts();
    console.log("results after comparison are ", results);
    return (_jsx("div", { className: " w-full ", children: _jsx("div", { className: "mb-4", children: _jsx("div", { className: "space-y-2", children: results.map((result) => (_jsxs("div", { className: "leading-relaxed", children: [_jsx("span", { className: "text-black", children: result.completeText.beforeReplacement }), _jsx("span", { className: "text-red-600", children: result.completeText.oldText }), ' ', _jsx("span", { className: "text-green-600", children: result.completeText.newText }), _jsx("span", { className: "text-black", children: result.completeText.afterReplacement })] }, result.index))) }) }) }));
};
export default TextDiffAnalyzer;
